import axios from "axios";
import { errorHandler } from "../exports/error_management";
import { buildQuery } from "../exports/queryStringBuilder";
import { StorageCache } from "../exports/dataStorage";
const storageKey = "ams-countries-key";

const openGeocoder = require("node-open-geocoder");
const countryLookup = require("country-code-lookup");

const countryLookupSafe = (progName, param) => {
  try {
    return countryLookup[progName](param);
  } catch (err) {
    console.log(`safeRun- ${progName}-${param}-`, err.message);
    return null;
  }
};

const cleanStreetAddress = (address) => {
  let addressParts = address.split(" ");
  //check first element and normalize number
  let addressNo = parseInt(addressParts[0]);
  if (addressNo) {
    addressParts[0] = addressNo.toString();
  }
  return addressParts.join(" ");
};

const state = {
  location: {},
  locations: [],
  country: [],
  states: [],
  section: null,
  pagination: null,
};

const getters = {
  warehouse_sections(state) {
    return state.locations.reduce((_sections, location) => {
      if (location.is_warehouse)
        _sections.push(
          ...location.sections.map(({ id, name }) => ({
            id,
            name: `${location.name}, ${name}`,
          }))
        );
      return _sections;
    }, []);
  },

  sections(state) {
    return (state.location || {}).sections || [];
  },

  section_master_items(state) {
    const section = state.section || {};
    return section.master_items || [];
  },

  locationSections(state) {
    return state.locations.reduce((_sections, _location) => {
      let xSections = [...(_location.sections || [])];
      const cleanedLocation = { ..._location };
      delete cleanedLocation.section;
      xSections = xSections.map((x) => {
        x.location = cleanedLocation;
        return x;
      });
      _sections = [..._sections, ...xSections];
      return _sections;
    }, []);
  },

  simpleLocation(state) {
    const {
      id,
      created_at,
      updated_at,
      name,
      address1,
      address2,
      city,
      state_name,
      county,
      postal_code,
      zip_code,
      country_code,
      latitude,
      longitude,
      // map_reference,
      is_warehouse,
    } = state.location;
    return {
      id,
      created_at,
      updated_at,
      name,
      address1,
      address2,
      city,
      county,
      state_name,
      postal_code,
      zip_code,
      country_code,
      latitude,
      longitude,
      // map_reference,
      is_warehouse,
    };
  },
};

const mutations = {
  SET_LOCATIONS(state, payload) {
    state.locations = payload;
  },

  SET_LOCATION_PAGINATION(state, pag) {
    state.pagination = pag;
  },

  SET_LOCATION(state, location) {
    state.location = location;
  },

  SET_SECTION(state, section) {
    state.section = section;
  },
  SET_COUNTRY(state, country) {
    state.country = country;
  },
  SET_STATES(state, states) {
    state.states = states;
  },
};

const actions = {
  ////location
  async fetchById(context, id) {
    try {    
      if (id) {
        const resp = await axios.get(`location/${id}`);
        context.commit("SET_LOCATION", resp.data.success.data);
      } else {
        context.commit("SET_LOCATION", {});
      }
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchByIdFunction(context, id) {
    try {
      const resp = await axios.get(`location/${id}`);
      return resp.data.success.data;
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchWarehouses(context) {
    try {
      const resp = await axios.get(`location/all_warehouses`);
      context.commit("SET_LOCATIONS", resp.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchCountry(context) {
    const storageCache = new StorageCache(storageKey);
    try {
      const { is_valid, value } = storageCache.getArray();
      if (!is_valid) {
        const results = await axios.get(`country/dependent-dropdown`);
        const data = results.data.countries;
        storageCache.set(data);
        value.splice(0);
        value.push(...data);
      }
      context.commit("SET_COUNTRY", value);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchstate(context, country_code = "JM") {
    const key = `ams-states-key-${country_code}`;
    const storageCache = new StorageCache(key);
    try {
      const { is_valid, value } = storageCache.getArray();
      if (!is_valid) {
        const resp = await axios.post(
          `country/fetch-states?country_code=${country_code}`
        );
        const data = resp.data.states;
        storageCache.set(data);
        value.splice(0);
        value.push(...data);
      }
      context.commit("SET_STATES", value);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchLocations(context, params) {
    try {
      // Destructure Params
      let { query, page: pg, filters } = params || {};

      // Initialize query params and filters if nothing is passed in
      query = query || "";
      pg = pg || 1;
      filters = filters || {};

      // Fetch location data based on query params
      const path = `location?q=${query}&page=${pg}&${buildQuery(filters)}`;
      const locationsData = await axios.get(path);

      // Destructure search data
      let {
        data,
        current_page: page,
        per_page: pageSize,
        total,
      } = locationsData.data.success.data;

      // Create pagination object
      const pag = {
        page,
        pageSize,
        total,
      };

      context.commit("SET_LOCATIONS", data);
      context.commit("SET_LOCATION_PAGINATION", pag);
    } catch (err) {
      errorHandler(err);
    }
  },
  async fetchAllLocations(context, params) {
    try {
      // Destructure Params
      let { query, filters } = params || {};

      // Initialize query params and filters if nothing is passed in
      query = query || "";
      filters = filters || {};

      // Fetch location data based on query params
      const path = `location?q=${query}&${buildQuery(filters)}`;
      const locationsData = await axios.get(path);

      // Destructure search data
      let { data } = locationsData.data.success.data;


      // Create pagination object
      // const pag = {
      //     page,
      //     pageSize,
      //     total,
      // }

      context.commit("SET_LOCATIONS", data);
      // context.commit('SET_LOCATION_PAGINATION', pag)
    } catch (err) {
      errorHandler(err);
    }
  },

  async create(context, { payload }) {
    try {
      const data = await axios.post(`location`, payload);
      const { section } = data.data.success.data;
      if (section) {
        context.commit("SET_SECTION", section);
      }
      // context.dispatch('fetchLocations') //not efficient
      //context.commit("SET_TYPE", data.success.data)
    } catch (err) {
      errorHandler(err);
    }
  },

  async update(context, { id, payload }) {
    try {
      const data = await axios.put(`location/${id}`, payload);
      console.log("update results", data);
      // context.dispatch('fetchLocations') //not efficient
      //context.commit("SET_TYPE", data.success.data)
    } catch (err) {
      errorHandler(err);
    }
  },

  async correctCustomerLocations() {
    try {
      await axios.post(`location/correct-addresses`);
    } catch (err) {
      errorHandler(err);
    }
  },

  async delete(context, id) {
    try {
      await axios.delete(`location/${id}`);
      // context.dispatch('fetchLocations') //not efficient
    } catch (err) {
      errorHandler(err);
    }
  },

  ////
  async getSection(_, location_section_id) {
    try {
      //const path = `location/section-details?id=${location_section_id}&items=0`
      if (location_section_id) {
        const path = `location/section-details/${location_section_id}?items=0`;
        const data = await axios.get(path);
        return data.data.success.data;
      }
    } catch (err) {
      errorHandler(err);
    }
  },

  async getSectionDetails(
    context,
    { location_section_id, include_master_items }
  ) {
    try {
      include_master_items = include_master_items ? 1 : 0;
      //const path = `location/?id=${location_section_id}&items=${include_master_items}`
      const path = `location/${location_section_id}?items=${include_master_items}`;
      const data = await axios.get(path);
      context.commit("SET_SECTION", data.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async createSection(context, { location_id, payload }) {
    try {     
      const path = `location/${location_id}/sections`;
      const data = await axios.post(path, payload);
      context.commit("SET_SECTION", data.data.success.data);
      context.dispatch("fetchById", location_id);
    } catch (err) {
      errorHandler(err);
    }
  },

  async updateSection(context, { id, location_id, payload }) {
    try {
      const path = `location/${location_id}/sections/${id}/update`;
      const data = await axios.put(path, payload);
      console.log("update results", data);
      context.dispatch("fetchById", location_id);
      // context.dispatch('fetchLocations') //not efficient
      //context.commit("SET_TYPE", data.success.data)
    } catch (err) {
      errorHandler(err);
    }
  },

  async deleteSection(context, { id, location_id }) {
    try {
      const path = `location/${location_id}/sections/${id}/delete`;
      await axios.delete(path);
      // context.dispatch('fetchLocations') //not efficient
      context.dispatch("fetchById", location_id);
      //context.commit("SET_TYPE", data.success.data)
    } catch (err) {
      errorHandler(err);
    }
  },

  async geocodeAddress(
    { dispatch },
    { address1, address2, city, country_code }
  ) {
    try {
      const { country } = countryLookupSafe("byIso", country_code);
      const streetArray = [
        [address1, address2, city],
        [address1, city],
        [address2, city],
        [address1, address2],
        [address1],
        [address2],
      ];

      const doGeoCode = async (arr) => {
        if (arr.every((x) => x)) {
          const street = cleanStreetAddress(arr.join(", "));
          return await dispatch("geocodeStreet", {
            street,
            country,
          });
        }
      };
      let results = [];
      for (let arr of streetArray) {
        results = await [...results, ...((await doGeoCode(arr)) || [])];
        if (results.length > 0) {
          break;
        }
      }
     
      const countryResults = results
        .filter((x) => x.address.country === country)
        .map((x) => {
          x.importance = 1000 * parseFloat(x.importance);
          return x;
        });
      countryResults.sort((a, b) => b.importance - a.importance);
      if (countryResults.length === 0) throw new Error("Address Not Found");
      const { lat: latitude, lon: longitude } = countryResults[0];
      return {
        latitude,
        longitude,
      };
    } catch (err) {
      errorHandler(err);
    }
  },

  geocodeStreet(context, { street, country }) {
    return new Promise((resolve) => {
      let q = `${street}, ${country}`;
      console.log("map query:", q);
      openGeocoder({
        port: 443,
      });
      openGeocoder()
        .geocode(q)
        .end((err, res) => {
          if (err) {
            console.error("geocodeStreet--err", err);
            //reject(err)
            return resolve();
          } else {
            return resolve(res);
          }
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
